<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/ops/dashboard">Ops</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page"
        >DF Invoices Queue</span
      >
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Debtors Finance — Invoices</h1>
        <p class="page-head__subtitle">{{ invoiceCount }} invoices</p>
      </div>
    </div>
  </header>

  @if (isLoading()) {
    <mat-card appearance="outlined" class="table-card" aria-label="Loading invoices">
      <table class="queue-table sg-table sg-table--skeleton" aria-hidden="true">
        <thead>
          <tr>
            <th>Debtor</th>
            <th>Invoice #</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Submitted</th>
          </tr>
        </thead>
        <tbody>
          @for (r of [1, 2, 3, 4, 5]; track r) {
            <tr>
              <td><span class="sg-skeleton sg-skeleton--text" style="width: 75%"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w50"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text" style="width: 55%"></span></td>
              <td><span class="sg-skeleton sg-skeleton--chip"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w60"></span></td>
            </tr>
          }
        </tbody>
      </table>
    </mat-card>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--bordered sg-empty--error">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load invoices</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="load()">
        <app-icon name="refresh" [size]="18" /> Try again
      </button>
    </div>
  } @else if (dataSource.data.length === 0) {
    <div class="sg-empty sg-empty--bordered">
      <app-icon name="document" [size]="40" />
      <p class="sg-empty__title">No invoices in queue yet</p>
      <p class="sg-empty__desc">Invoices submitted for review will appear here.</p>
    </div>
  } @else {
    <mat-card appearance="outlined" class="table-card">
      <table mat-table [dataSource]="dataSource" class="queue-table">
        <ng-container matColumnDef="debtor">
          <th mat-header-cell *matHeaderCellDef>Debtor</th>
          <td mat-cell *matCellDef="let inv">{{ inv.debtor_name }}</td>
        </ng-container>

        <ng-container matColumnDef="invoice_number">
          <th mat-header-cell *matHeaderCellDef>Invoice #</th>
          <td mat-cell *matCellDef="let inv">{{ inv.invoice_number }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let inv">{{ inv.invoice_amount | zar }}</td>
        </ng-container>

        <ng-container matColumnDef="invoice_status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let inv">
            <app-status-chip [status]="inv.invoice_status" />
          </td>
        </ng-container>

        <ng-container matColumnDef="submitted">
          <th mat-header-cell *matHeaderCellDef>Submitted</th>
          <td mat-cell *matCellDef="let inv">
            {{ inv.created_at | date: 'mediumDate' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr
          mat-row
          *matRowDef="let inv; columns: columns"
          class="queue-table__row"
          [routerLink]="['/ops/df/invoices', inv.short_id]"
        ></tr>
      </table>

      @if (dataSource.data.length > pageSizeOptions[0]) {
        <mat-paginator [pageSizeOptions]="pageSizeOptions" aria-label="Select page of invoices" />
      }
    </mat-card>
  }
</div>
